import { NgModule } from '@angular/core';
import { BrowserModule }  from '@angular/platform-browser';

import { provideAuth } from 'angular2-jwt';
import { Cookie } from 'ng2-cookies/ng2-cookies';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { SharedModule } from './shared/shared.module';

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    AuthModule
  ],
  declarations: [
    AppComponent
  ],
  providers: [
    provideAuth({
      headerName: "Authorization",
      headerPrefix: "Bearer",
      tokenName: "id_token",
      tokenGetter: (() => Cookie.get("id_token")),
      globalHeaders: [{'Content-Type':'application/json'}],
      noJwtError: true,
      noTokenScheme: true
    })

  ],
  bootstrap: [ AppComponent ]
})

export class AppModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-router-loader/src!./~/angular2-template-loader!./src/app/app.module.ts
 **/